import * as React from "react";
import DialogContentText from "@mui/material/DialogContentText";
import { Stack, TextField } from "@mui/material";
import CclDrawer from "../../../components/common/cclDrawer/cclDrawer";
import CclDrawerActionBar from "../../../components/common/cclDrawer/cclDrawerActionBar";
import CclButton from "../../../components/common/cclButtons/cclButton";
import CclLoadingButton from "../../../components/common/cclButtons/cclLoadingButton";
import { validateEmail } from "../../../utilities/generalUtilities";

export type CclEnterNewFacilitatorDrawerProps = {
    open: boolean;
    onOk: (email: string) => void;
    onCancel: () => void;
    saving: boolean;
};

const CclEnterNewFacilitatorDrawer: React.FC<CclEnterNewFacilitatorDrawerProps> = (props) => {
    const [newFacEmail, setNewFacEmail] = React.useState<string>("");
    const [inputError, setInputError] = React.useState<string>("");

    React.useEffect(() => {
        if (props.open) return;
        setNewFacEmail("");
    }, [props.open]);

    const handleOk = () => {
        if (validateEmail(newFacEmail)) {
            setInputError("");
            props.onOk(newFacEmail.trim());
        } else {
            setInputError("Not a valid email address");
        }
    };

    const handleKeyPress = async (evt: React.KeyboardEvent<HTMLDivElement>) => {
        if (evt.key === "Enter") {
            handleOk();
        }
    };

    return (
        <CclDrawer
            open={props.open}
            onClose={() => setNewFacEmail("")}
            title={"Change Facilitator"}
        >
            <Stack direction="row" alignItems={"center"}>
                <DialogContentText id="alert-dialog-description" sx={{ width: 1 }}>
                    <TextField
                        size="small"
                        name="facilitatorEmail"
                        placeholder="Enter New Facilitator's Email"
                        value={newFacEmail}
                        id="outlined-adornment-email-search"
                        label="Enter New Facilitator's Email"
                        variant="outlined"
                        fullWidth={true}
                        error={inputError !== ""}
                        helperText={inputError}
                        onChange={(e) => {
                            e.preventDefault();
                            setNewFacEmail(e.target.value);
                        }}
                        onKeyDown={(e) => handleKeyPress(e)}
                        sx={{ mt: "10px" }}
                    />
                </DialogContentText>
            </Stack>
            <CclDrawerActionBar>
                <CclLoadingButton
                    onClick={handleOk}
                    disabled={newFacEmail.length <= 3}
                    loading={props.saving}
                    mode={"primary"}
                >
                    Save
                </CclLoadingButton>
                <CclButton onClick={props.onCancel} mode={"secondary"}>
                    Cancel
                </CclButton>
            </CclDrawerActionBar>
        </CclDrawer>
    );
};

export default CclEnterNewFacilitatorDrawer;
